import { Sprite } from "../display/Sprite";
import { Spine2DRenderNode } from "./Spine2DRenderNode";
export class SpineSkeleton extends Sprite {
    constructor() {
        super();
        this._spineComponent = this.addComponent(Spine2DRenderNode);
    }
    get externalSkins() {
        return this._spineComponent.externalSkins;
    }
    set externalSkins(value) {
        this._spineComponent.externalSkins = value;
    }
    resetExternalSkin() {
        this._spineComponent.resetExternalSkin();
    }
    get source() {
        return this._spineComponent.source;
    }
    set source(value) {
        this._spineComponent.source = value;
    }
    get skinName() {
        return this._spineComponent.skinName;
    }
    set skinName(value) {
        this._spineComponent.skinName = value;
    }
    get animationName() {
        return this._spineComponent.animationName;
    }
    set animationName(value) {
        this._spineComponent.animationName = value;
    }
    get loop() {
        return this._spineComponent.loop;
    }
    set loop(value) {
        this._spineComponent.loop = value;
    }
    get templet() {
        return this._spineComponent.templet;
    }
    set templet(value) {
        this._spineComponent.templet = value;
    }
    set currentTime(value) {
        this._spineComponent.currentTime = value;
    }
    get playState() {
        return this._spineComponent.playState;
    }
    get spineItem() {
        return this._spineComponent.spineItem;
    }
    set spineItem(value) {
        this._spineComponent.spineItem = value;
    }
    play(nameOrIndex, loop, force = true, start = 0, end = 0, freshSkin = true, playAudio = true) {
        this._spineComponent.play(nameOrIndex, loop, force, start, end, freshSkin, playAudio);
    }
    getAnimNum() {
        return this._spineComponent.getAnimNum();
    }
    getAniNameByIndex(index) {
        return this._spineComponent.getAniNameByIndex(index);
    }
    getSlotByName(slotName) {
        return this._spineComponent.getSlotByName(slotName);
    }
    playbackRate(value) {
        this._spineComponent.playbackRate(value);
    }
    showSkinByName(name) {
        this._spineComponent.showSkinByName(name);
    }
    showSkinByIndex(skinIndex) {
        this._spineComponent.showSkinByIndex(skinIndex);
    }
    stop() {
        this._spineComponent.stop();
    }
    paused() {
        this._spineComponent.paused();
    }
    resume() {
        this._spineComponent.resume();
    }
    destroy(destroyChild = true) {
        if (this._spineComponent.templet) {
            this._spineComponent.reset();
        }
        super.destroy(destroyChild);
    }
    addAnimation(nameOrIndex, loop = false, delay = 0) {
        this._spineComponent.addAnimation(nameOrIndex, loop, delay);
    }
    setMix(fromNameOrIndex, toNameOrIndex, duration) {
        this._spineComponent.setMix(fromNameOrIndex, toNameOrIndex, duration);
    }
    getBoneByName(boneName) {
        return this._spineComponent.getBoneByName(boneName);
    }
    getSkeleton() {
        return this._spineComponent.getSkeleton();
    }
    setSlotAttachment(slotName, attachmentName) {
        this._spineComponent.setSlotAttachment(slotName, attachmentName);
    }
}
export var ESpineRenderType;
(function (ESpineRenderType) {
    ESpineRenderType[ESpineRenderType["boneGPU"] = 0] = "boneGPU";
    ESpineRenderType[ESpineRenderType["normal"] = 1] = "normal";
    ESpineRenderType[ESpineRenderType["rigidBody"] = 2] = "rigidBody";
})(ESpineRenderType || (ESpineRenderType = {}));
class TimeKeeper {
    constructor(timer) {
        this.maxDelta = 0.064;
        this.timer = timer;
    }
    update() {
        this.delta = this.timer.delta / 1000;
        if (this.delta > this.maxDelta)
            this.delta = this.maxDelta;
    }
}
